import axios from 'axios';
import { isObjectNotEmpty, isStringNotEmpty } from './objectUtils';

export const getClientIPAddress = async () => {
    try {
        // bounded: this runs in already-degraded network conditions where an unbounded request
        // would hang tracking initialization and the analytics queue behind it
        const res = await axios.get('https://api.ipify.org/?format=json', { timeout: 2000 });
        if (isObjectNotEmpty(res) && isObjectNotEmpty(res.data) && isStringNotEmpty(res.data.ip)) {
            return res.data.ip;
        }
    } catch (error) {
        // callers treat a missing ip as optional - a timeout or blocked lookup must not
        // abort checkout, signup, or tracking flows that await this
    }

    return null;
};

export const getClientUserAgent = () => {
    return window.navigator.userAgent;
};

export const getReferrerUrl = () => {
    return isStringNotEmpty(document.referrer) ? document.referrer : (isStringNotEmpty(window.frames.top.document.referrer) ? window.frames.top.document.referrer : null);
};

/**
 * Extracts a query string parameter from a given URL string.
 * @param {string} urlString The full URL string to parse.
 * @param {string} paramName The name of the parameter to extract (e.g., 'id').
 * @returns {string | null} The value of the parameter, or null if not found.
 */
export const getQueryParam = (urlString, paramName) => {
    try {
        // 1. Create a URL object from the string
        const url = new URL(urlString);

        // 2. Access the URLSearchParams object
        const params = url.searchParams;

        // 3. Use the 'get' method to retrieve the parameter value
        return params.get(paramName) || null;
    } catch (error) {
        console.error("Invalid URL:", error);
        return null;
    }
};